import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Page direction and Bootstrap's RTL build follow the language (Arabic is right-to-left).
// public/index.html applies the same before first paint.
i18next.on("languageChanged", (lng) => {
  const dir = i18next.dir(lng);
  document.documentElement.dir = dir;
  document.documentElement.lang = (lng || "en").slice(0, 2);
  const bootstrap = document.getElementById("bootstrap-css");
  if (bootstrap) {
    const href = `${process.env.PUBLIC_URL}/assets/css/${dir === "rtl" ? "bootstrap.rtl.min.css" : "bootstrap.min.css"}`;
    if (bootstrap.getAttribute("href") !== href) bootstrap.setAttribute("href", href);
  }
});

i18next
  .use(initReactI18next)
  .use(HttpApi)// Registering the back-end plugin
  .use(LanguageDetector)  // Registering the detection plugin
  .init({
    // Remove resources from here
    // lng: "en",
    // Allowed languages
    // Keep in sync with LANGUAGES (components/LocaleSwitcher.js) and the backend's
    // config/translation.php locales.
    supportedLngs: ["en", "ar", "fr", "de", "it", "pt", "zh", "ja", "hi"],
    // Allows "en-US" and "en-UK" to be implcitly supported when "en"
    // is supported
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },
    // translation files keep the same name across deploys; the build id busts browser caches
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${process.env.REACT_APP_BUILD_ID || "dev"}`,
    },
    debug: process.env.NODE_ENV === "development",
  });
export default i18next;